import React from "react"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { LoadingSpinner } from "../../components"

const useStyles = makeStyles(() => ({
  spinner: {
    height: "100vh",
  },
}))

const LoginDeviceBusy = () => {
  const classes = useStyles()

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={-10}
      alignItems="center"
      className={classes.spinner}
    >
      <Box display="flex" justifySelf="flex-start" alignSelf="center" mt={3}>
        <LoadingSpinner size={85} />
      </Box>
    </Box>
  )
}

export { LoginDeviceBusy }
